<template>
    <div class="purchase_part my-2">
        <cabinet-fl44-card-header :purchase="purchase" />
        <cabinet-fl44-card-subheader :purchase="purchase" />
        <cabinet-fl44-card-body>
            <template v-slot:col1>
                <template v-if="purchase.flags.notice_approval_needed">
                    <p class="font-weight-bold fs-14 m-0 pb-2 text-danger" v-if="purchase.actions.request_approval && !purchase.approval_info">Требуется согласование</p>
                    <p class="font-weight-bold fs-14 m-0 pb-2" :class="purchase.approval_info.status.class" v-else-if="purchase.approval_info && purchase.approval_info.status">{{ purchase.approval_info.status.title }}</p>
                </template>

                <cabinet-notice-card-row-dual v-if="purchase.status.id === 'accepting' && !!purchase.purchase_info.purchase_end" label="До окончания подачи предложений">
                    <timer-new :data="purchase.purchase_info.purchase_end" />
                </cabinet-notice-card-row-dual>
                <cabinet-notice-card-row-single v-if="purchase.purchase_info.planned_end_date ?? purchase.purchase_info.planned_contract_execution_date" label="Планируемая дата исполнения">{{ getDateFormat(purchase.purchase_info.planned_end_date ?? purchase.purchase_info.planned_contract_execution_date) }}</cabinet-notice-card-row-single>
                <purchase-comment-edit-block v-if="purchase.flags.is_customer" :purchase="purchase" :type="purchase.type" @refresh="refresh" />
            </template>
            <template v-slot:col2>
                <cabinet-notice-card-row-dual v-if="purchase.purchase_info.purchase_name" label="Предмет закупки">{{ purchase.purchase_info.purchase_name }}</cabinet-notice-card-row-dual>
                <cabinet-notice-card-row-single label="Количество позиций">{{ purchase.purchase_info.deliverables_count }}</cabinet-notice-card-row-single>
                <cabinet-notice-card-row-dual v-if="purchase.purchase_info.delivery_addresses && purchase.purchase_info.delivery_addresses.length" label="Адреса для доставки товаров/выполнения работ/оказания услуг">
                    <p v-for="(address, index) in purchase.purchase_info.delivery_addresses" :key="`${purchase.id}_address_${index}`" class="fs-12 m-0 grey-color fw-600">&mdash;&nbsp;{{ address.address }}</p>
                </cabinet-notice-card-row-dual>
            </template>
            <template v-slot:col3>
                <cabinet-fl44-unknown-volume-card-info-links :purchase="purchase" />
                <div class="my-2">
                    <cabinet-fl44-notice-card-edit-button :purchase="purchase" />
                    <cabinet-fl44-notice-card-request-approval-button :purchase="purchase" @action="refresh" />
                    <cabinet-fl44-notice-card-publish-button :purchase="purchase" @action="refresh" />
                    <cabinet-fl44-notice-card-delete-button :purchase="purchase" @action="refresh" />
                    <cabinet-fl44-notice-card-prolong-button :purchase="purchase" @action="refresh" />
                    <cabinet-fl44-notice-card-cancel-button :purchase="purchase" @action="refresh" />
                    <cabinet-fl44-notice-card-unpublish-button :purchase="purchase" @action="refresh" />
                    <cabinet-fl44-notice-card-duration-change-button :purchase="purchase" />
                    <cabinet-fl44-notice-card-answer-explanation-request-button :purchase="purchase" />
                    <cabinet-fl44-notice-card-store-protocol-button :purchase="purchase" />
                    <cabinet-fl44-notice-card-copy-button :purchase="purchase" />

                    <b-button :to="{ ...link, hash: '#atmo-contract' }" target="_blank" class="btn btn-card-action btn-card-action-danger my-1" v-if="purchase.actions.send_contract"> Отправить контракт </b-button>
                    <b-button :to="{ ...link, hash: '#atmo-disputes-resolution' }" target="_blank" class="btn btn-card-action btn-card-action-danger my-1" v-if="purchase.actions.answer_dispute">
                        Ответить на протокол разногласий
                    </b-button>
                    <b-button v-bind:to="{ ...link, hash: '#atmo-contract' }" target="_blank" class="btn btn-card-action btn-card-action-danger my-1" v-if="purchase.actions.sign_contract"> Подписать контракт </b-button>
                    <b-button v-bind:to="{ ...link, hash: '#atmo-contract-annexes' }" target="_blank" class="btn btn-card-action btn-card-action-danger my-1" v-if="purchase.actions.sign_supplementary_agreement">
                        Подписать дополнительное соглашение
                    </b-button>
                </div>
                <cabinet-fl44-notice-card-block-info :purchase="purchase" />
            </template>
        </cabinet-fl44-card-body>
    </div>
</template>

<script>
import TimerNew from '@/components/elements/TimerNew';
import PurchaseCommentEditBlock from '@/components/common/purchase-comment-edit-block';
import CabinetFl44NoticeCardCancelButton from '@/components/cabinet/fl44/cards/partials/cabinet-fl44-notice-card-cancel-button.vue';
import CabinetFl44NoticeCardCopyButton from '@/components/cabinet/fl44/cards/partials/cabinet-fl44-notice-card-copy-button.vue';
import CabinetNoticeCardRowDual from '@/components/cabinet/partials/cabinet-notice-card-row-dual.vue';
import CabinetNoticeCardRowSingle from '@/components/cabinet/partials/cabinet-notice-card-row-single.vue';
import CabinetFl44NoticeCardPublishButton from '@/components/cabinet/fl44/cards/partials/cabinet-fl44-notice-card-publish-button.vue';
import CabinetFl44NoticeCardDeleteButton from '@/components/cabinet/fl44/cards/partials/cabinet-fl44-notice-card-delete-button.vue';
import CabinetFl44NoticeCardProlongButton from '@/components/cabinet/fl44/cards/partials/cabinet-fl44-notice-card-prolong-button.vue';
import CabinetFl44NoticeCardUnpublishButton from '@/components/cabinet/fl44/cards/partials/cabinet-fl44-notice-card-unpublish-button.vue';
import CabinetFl44NoticeCardEditButton from '@/components/cabinet/fl44/cards/partials/cabinet-fl44-notice-card-edit-button.vue';
import CabinetFl44NoticeCardAnswerExplanationRequestButton from '@/components/cabinet/fl44/cards/partials/cabinet-fl44-notice-card-answer-explanation-request-button.vue';
import CabinetFl44CardSubheader from '@/components/cabinet/fl44/cards/partials/cabinet-fl44-card-subheader.vue';
import CabinetFl44CardHeader from '@/components/cabinet/fl44/cards/partials/cabinet-fl44-card-header.vue';
import CabinetFl44CardBody from '@/components/cabinet/fl44/cards/partials/cabinet-fl44-card-body.vue';
import CabinetFl44NoticeCardStoreProtocolButton from '@/components/cabinet/fl44/cards/partials/cabinet-fl44-notice-card-store-protocol-button.vue';
import CabinetFl44NoticeCardBlockInfo from '@/components/cabinet/fl44/cards/partials/cabinet-fl44-notice-card-block-info.vue';
import CabinetFl44NoticeCardRequestApprovalButton from '@/components/cabinet/fl44/cards/partials/cabinet-fl44-notice-card-request-approval-button.vue';
import CabinetFl44UnknownVolumeCardInfoLinks from '@/components/cabinet/fl44/cards/partials/cabinet-fl44-unknown-volume-card-info-links.vue';
import CabinetFl44NoticeCardDurationChangeButton from '@/components/cabinet/fl44/cards/partials/cabinet-fl44-notice-card-duration-change-button.vue';

export default {
    name: 'cabinet-fl44-unknown-volume-notice-card',
    props: {
        purchase: {
            type: Object,
            required: true
        }
    },
    components: {
        CabinetFl44NoticeCardDurationChangeButton,
        CabinetFl44UnknownVolumeCardInfoLinks: CabinetFl44UnknownVolumeCardInfoLinks,
        CabinetFl44NoticeCardRequestApprovalButton,
        CabinetFl44NoticeCardBlockInfo,
        CabinetFl44NoticeCardStoreProtocolButton,
        CabinetFl44CardBody,
        CabinetFl44CardHeader,
        CabinetFl44CardSubheader,
        CabinetFl44NoticeCardAnswerExplanationRequestButton,
        CabinetFl44NoticeCardEditButton,
        CabinetFl44NoticeCardUnpublishButton,
        CabinetFl44NoticeCardProlongButton,
        CabinetFl44NoticeCardDeleteButton,
        CabinetFl44NoticeCardPublishButton,
        CabinetFl44NoticeCardCancelButton,
        CabinetNoticeCardRowSingle,
        CabinetNoticeCardRowDual,
        CabinetFl44NoticeCardCopyButton,
        TimerNew,
        PurchaseCommentEditBlock
    },
    methods: {
        refresh() {
            this.$emit('refresh');
        }
    },
    computed: {
        link() {
            return this.purchase.type === 'fl44' ? { name: 'purchases.grouped.item.view', params: { group: 'fl44', id: this.purchase.id } } : { name: 'Fl44UnknownVolumePurchaseShow', params: { id: this.purchase.id } };
        }
    }
};
</script>

<style scoped>
.purchase_part {
    background: #fff;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    border: 1px solid #d9d9de;
}
</style>
